module.exports = __webpack_public_path__ + "img/Icon_previous.dc99b759.png";